import { SystemStyleObject } from '@chakra-ui/react';

const entityDirectoryControlStyles: SystemStyleObject = {
  '& .chakra-form__label': {
    color: 'entityDirectory.secondaryText !important',
  },
  '& .chakra-input, & .chakra-select, & .chakra-textarea, & .chakra-numberinput__field':
    {
      background: 'entityDirectory.inputBackground',
      borderColor: 'entityDirectory.secondaryBorder',
      borderRadius: 0,
      color: 'entityDirectory.text',
    },
  '& .chakra-select__icon': {
    color: 'entityDirectory.mutedText',
  },
};

export const configurationPageStyles: Record<string, SystemStyleObject> = {
  toolbar: {
    minH: '62px',
    alignItems: 'center',
    gap: 3,
    flexWrap: 'wrap',
    px: 3.5,
    py: 3,
    bg: 'entityDirectory.surface',
    border: '1px solid',
    borderColor: 'entityDirectory.border',
    ...entityDirectoryControlStyles,
    '& > .chakra-input__group': {
      flex: '1 1 280px',
      maxW: { base: 'full', lg: '340px' },
      '& .chakra-input': {
        background: 'transparent',
      },
    },
  },
};

export const complianceDocumentTypeStyles: Record<string, SystemStyleObject> = {
  options: {
    gridTemplateColumns: { base: '1fr', md: 'repeat(2, minmax(0, 1fr))' },
    gap: 3,
    '& .chakra-radio': {
      alignItems: 'flex-start',
      bg: 'entityDirectory.raisedSurface',
      border: '1px solid',
      borderColor: 'entityDirectory.border',
      m: 0,
      minW: 0,
      p: 3,
      whiteSpace: 'normal',
      width: '100%',
    },
    '& .chakra-radio[data-checked]': {
      borderColor: 'entityDirectory.primaryBackground',
    },
    '& .chakra-radio__label': {
      flex: 1,
      minW: 0,
    },
  },
};

export function getConfigurationContentStyle(
  hasToolbar: boolean,
  editorSurface: boolean,
): SystemStyleObject {
  return {
    minH: hasToolbar ? 'calc(100vh - 250px)' : 'calc(100vh - 168px)',
    bg: editorSurface ? 'entityDirectory.surface' : 'entityDirectory.canvas',
    color: 'entityDirectory.text',
    '& .chakra-table': {
      background: 'entityDirectory.surface',
      border: '1px solid',
      borderColor: 'entityDirectory.border',
    },
    ...entityDirectoryControlStyles,
  };
}

export const configurationNavigationStyles: Record<string, SystemStyleObject> =
  {
    root: {
      flexDirection: 'column',
      h: '100%',
      bg: 'navigation.contextBackground',
    },
    header: {
      color: 'chakra-body-text',
      fontFamily: 'barlow',
      fontSize: 'lg',
      fontWeight: 'extrabold',
      flexShrink: 0,
      px: 2.5,
      pt: 2,
      pb: 4,
    },
    items: {
      flexDirection: 'column',
      flex: 1,
      minH: 0,
      px: 3,
      py: 3,
      bg: 'navigation.contextBackground',
      borderRightWidth: '1px',
      borderRightColor: 'navigation.contextBorder',
      overflowY: 'auto',
    },
  };
